/*
 * @Description: mark
 * @Author: wangwangwang
 * @Date: 2020-11-20 10:27:35
 * @LastEditors: wangwangwang
 * @LastEditTime: 2020-12-01 17:04:17
 */
import request from '@/utils/request'
export const queryPage = '/icps/system/sign/dataCollection/ratio/QueryPage'
export const saveOrUpdate = '/icps/system/sign/dataCollection/ratio/saveOrUpdate'
export const Download = '/icps/system/sign/dataCollection/supplier/exportList'

export function saveOrUpdate2(data) {
  return request({
    url: '/icps/system/sign/dataCollection/ratio/saveOrUpdate',
    method: 'post',
    data
  })
}
